import api from "./api";

const validationService = {};

validationService.get = function (params = {}) {
  return api.get("/validations", { params }).then((res) => res.data);
};

export default validationService;
